export default __webpack_public_path__ + "static/discord-cta-min-fcf7ba910d9cacf9cedb5ccdbb6861b7.png";